<div class="flex flex-col gap-[150px] w-full">
  <div class="flex max-w-screen-xl w-full mx-auto flex-col md:flex-row gap-5 items-stretch">
    <div class="bg-brand-primary rounded-[50px] w-full md:w-1/2 py-[76px] px-[50px] flex flex-col gap-y-5">
      <p class="title">{{(entity() === ROLES.EMPLOYER ? 'signup.employer.title' : 'signup.candidate.title') |
        translate }}</p>
      <p class="description">{{(entity() === ROLES.EMPLOYER ? 'signup.employer.subtitle_left' :
        'signup.candidate.subtitle_left' )| translate }}</p>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4 w-full sm:w-56">
        <div class="flex flex-col gap-[7px] ">
          <label class="label-access" for="email">{{'app.email' | translate }}</label>
          <div class="input-field">
            <div class="input-field-container">
              <input class="input-field-control" type="email" id="email" placeholder="example@email.com"
                formControlName="email" />
              @if (isInvalid('email')) {
              @if (loginForm.get('email')?.errors?.['required']) {
              <p-message severity="error" size="small" variant="simple">{{ 'errors.email_required' | translate
                }}</p-message>
              }
              @if (loginForm.get('email')?.errors?.['email']) {
              <p-message severity="error" size="small" variant="simple">{{ 'errors.email_valid' | translate
                }}</p-message>
              }
              }
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-[7px]">
          <label class="label-access" for="password">{{'app.password' | translate }}</label>
          <div class="input-field">
            <div class="input-field-container">
              <input class="input-field-control" type="password" id="password" placeholder="password"
                formControlName="password" />
              @if (isInvalid('password')) {
              <p-message severity="error" size="small" variant="simple">{{ 'errors.password_required' | translate
                }}</p-message>
              }
            </div>
          </div>
        </div>
        <app-buttons type="submit" [label]="'signup.signup' | translate" (click)="onSubmit()"
          [btnClass]="BUTTON_CLASS_TYPES.SECONDARY"></app-buttons>
      </form>
    </div>
    <div
      class="bg-brand-tertiary rounded-[50px] shadow-tertiary w-full md:w-1/2 py-[76px] px-[50px] flex flex-col gap-y-[30px]">
      <p><span class="title">{{'signup.shared.not_yet_account' | translate }}</span><span
          class="title text-brand-primary">{{'signup.shared.subscribe' | translate }}</span>
        <span class="title">{{'signup.shared.today' | translate }}</span>
      </p>
      <p class="description"
        [innerHTML]="(entity() === ROLES.EMPLOYER ? 'signup.employer.subtitle_right' : 'signup.candidate.subtitle_right')| translate">
      </p>
      @for (point of points; track point) {
      <div class="flex flex-row gap-2 items-start">
        <span class="block bg-brand-primary rounded-sm w-[24px] h-[24px]"></span><span
          class="list-points">{{point}}</span>
      </div>
      }
      <app-buttons type="button" [label]="'signup.register' | translate" (click)="register()"></app-buttons>
    </div>
  </div>
</div>